export function marker<T extends string | string[]>(key: T): T {
  return key;
}
